import { getRegionList } from "@/api/common";

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path);
}
 

export function timeFormat(timestamp) {
    if (!timestamp) {
      return timestamp;
    }
  
    var value = String(timestamp).length < 13 ? parseInt(timestamp) * 1000 : parseInt(timestamp);
    var time = new Date(value);
    const utc = time.getTime() + time.getTimezoneOffset() * 60000;
    const iaDate = new Date(utc + 480 * 60000); // 480 minutes = 8 hours

    var year = iaDate.getFullYear();
    var month = iaDate.getMonth() + 1;
    var date = iaDate.getDate();
    var hour = iaDate.getHours();
    var minute = iaDate.getMinutes();
    var second = iaDate.getSeconds();
    month = month < 10 ? "0" + month : month;
    date = date < 10 ? "0" + date : date;
    hour = hour < 10 ? "0" + hour : hour;
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    return (
      year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second
    );
}

/**
     * 时间戳转成日期
     * */

export function formatTime(_timestamp, _format) {
    if (!_timestamp) {
        return _timestamp;
    }
    var timestamp = String(_timestamp).length <= 10 ? parseInt(_timestamp) * 1000 : parseInt(_timestamp);
    var format = _format || "yyyy-MM-dd";
    const date = new Date(timestamp);
    const utc = date.getTime() + date.getTimezoneOffset() * 60000;
    const iaDate = new Date(utc + 480 * 60000); // 480 minutes = 8 hours

    const year = iaDate.getFullYear();
    const month = (iaDate.getMonth() + 1).toString().padStart(2, '0');
    const day = iaDate.getDate().toString().padStart(2, '0');
    const hours = iaDate.getHours().toString().padStart(2, '0');
    const minutes = iaDate.getMinutes().toString().padStart(2, '0');
    const seconds = iaDate.getSeconds().toString().padStart(2, '0');
    
    format = format.replace('yyyy', year);
    format = format.replace('MM', month);
    format = format.replace('dd', day);
    format = format.replace('HH', hours);
    format = format.replace('mm', minutes);
    format = format.replace('ss', seconds);
    
    return format;
}

export function getRegion(pid) {
    getRegionList(pid).then((res)=>{
        return res.data
    })
}


export function topicTypeText(id) {
    switch (id) {
        case 1:
          return {
            title: "单选题",
            type: "primary",
          };
        case 2:
          return {
            title: "多选题",
            type: "success",
          };
        case 3:
          return {
            title: "判断题",
            type: "danger",
          };
    
        case 4:
            return {
                title: "问答题",
                type: "primary",
            };
    
        case 5:
            return {
                title: "填空题",
                type: "warning",
            };
    
        case 6:
            return {
                title: "案例题",
                type: "success",
              };
        
        default: 
            return "";
      }
  }

export function topicTypeList() {
    return [
        {
            id: 1,
            name: "单选题",
        },
        {
            id: 2,
            name: "多选题",
        },
        {
            id: 3,
            name: "判断题"
        },
        {
            id: 4,
            name: "问答题"
        },
        {
            id: 5,
            name: "填空题"
        },
        {
            id: 6,
            name: "案例题"
        },
    ]
}

export function difficultyText(id) {
    switch (id) {
        case 1:
            return {type: "danger", name: "难"};
          
        case 2:
            return {type: "warning", name: "中"};
    
        case 3:
            return {type: "primary", name: "易"};
        
        default: 
            return {};
      } 
}

export function difficultyList() {
    return [
        {
            id: 1,
            name: "难"
        },
        {
            id: 2,
            name: "中"
        },
        {
            id: 3,
            name: "易"
        },
    ]
}

/**
 * 检查是否手机号码
 * @param {*} mobile 
 * @returns {Boolean}
 */
export function isMobile(mobile) {
    var reg = /^1[3-9]\d{9}$/;
    return reg.test(mobile);
}

/**
 * 检查是否邮箱
 * @param {*} email 
 * @returns {Boolean}
 */
export function isEmail(email) {
    var reg = /^[\w\+\-]+(\.[\w\+\-]+)*@[a-z\d\-]+(\.[a-z\d\-]+)*\.([a-z]{2,4})$/i;
    return reg.test(email);
}


/**
 * 违规类型
 * @param {*} email 
 * @returns {Boolean}
 */
export function cheatList() {
   return [{
        id: 1,
        name: "使用电子设备"
    },{
        id: 2,
        name: "查看资料"
    },{
        id: 3,
        name: "涉嫌替考"
    },{
        id: 4,
        name: "考生离开考位"
    },{
        id: 5,
        name: "多人入境"
    },{
        id: 6,
        name: "有人帮助考试"
    },{
        id: 7,
        name: "遮挡摄像头"
    },{
        id: 9,
        name: "掉线"
    }]
}

export function replacePoint(data, attr) {
    if(!data) {
        return;
    }
    var replace_w = attr || "-"
    return data.replaceAll(".", replace_w);
}

